<template>
    <div>
      <training-toolbar v-if="userInfo"/>
      <div class="card mx-md-5 mt-3 mb-3 bg-form">
        <card-header v-if="userInfo"
          :title="$t('parametrics.announcementsTitle')"
          :iconName="'folder'"
        />
        <b-card-body>
          <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>
          <b-alert v-for="error in errors" :key="error.message" v-model="popAlert"  variant="danger" dismissible>
            {{ error.message }}
          </b-alert>
          <template v-if="this.showWithdrawTemplate">
            <div class="card" style="margin-bottom: 2%;">
              <b-card-header class="esep-blue-bg text-light">
                <h6  class="float-left font-weight-bold">{{ $t('parametrics.withdrawTemplate')}} </h6>
              </b-card-header>
              <b-overlay :show="isLoading" :spinner-small="true" rounded="sm">
              <b-card-body>
                <b-row>
                  <b-form-group
                  id="withdrawid"
                  :label="$t('parametrics.announcementsId')"
                  label-for="input-withdraw-id"
                  label-align="left"
                  class="col-md-2"
                  >
                    <b-form-input 
                    id="input-withdraw-id"
                    type="text"
                    v-model="this.templateToWithdraw.id"
                    disabled
                    />
                  </b-form-group>
                  <b-form-group
                  id="withdrawtitle"
                  :label="$t('parametrics.announcementTitle')"
                  label-for="input-withdraw-title"
                  label-align="left"
                  class="col-md-2"
                  >
                    <b-form-input 
                    id="input-withdraw-title"
                    type="text"
                    v-model="this.templateToWithdraw.title"
                    disabled
                    />
                  </b-form-group>
                </b-row>
                <div class="float-left mt-2"  style="margin-bottom: 2%;">
                    <b-button @click="deleteTemplate" variant="success" class="mr-1">{{
                      $t("common.submit")
                    }}</b-button>
                    <b-button @click="hideWithdrawTemplate" variant="danger" >{{
                      $t("common.cancel")
                    }}</b-button>
                  </div>
                </b-card-body>
              </b-overlay>
            </div>
          </template>
          <template>
            <announcementsTable :announcements="Announcements" @show-withdraw-template="showWithdrawTemplateFn" v-on:error:api.capture="handleError"/>
          </template>
        </b-card-body>
      </div>
    </div>
  </template>
  
<script>
import CardHeader from '../../components/common/cardHeader.vue';
import trainingService from '../../services/training.service';
import { handleApiError } from '../../services/error.service';
import TrainingToolbar from '../../components/common/trainingToolbar.vue';
import {hasRole} from "esep/src/services/utils";
import {roles, routes} from "esep/src/services/routing.service";
import announcementsTable from '../../components/parametrics/announcementsTable.vue';
  
export default {
  components: {
    CardHeader,
    TrainingToolbar,
    announcementsTable
  },
  mounted() {
    trainingService.getUserInfo(this.username).then(
      (response) => {
        this.userInfo = response.data;
        if (!hasRole(this.userInfo,roles.training.parametrics)){
          location.replace(routes.nothing);
        }
        this.$store.state.userInfo = this.userInfo;
        this.fetchRoles();
      },
      (error) => {
        let errorMessage = handleApiError(error);
        this.handleError(errorMessage);
      }
    );
    this.getAnnouncementsTemplatesByCriteria(true, 'FLEX_MODULE');
  },
  data() {
    return {
      userInfo: null,
      popSuccessAlert: false,
      popAlert: false,
      successMessage: null,
      errors: null,
      isAdmin: false,
      isTrainingAdmin: false,
      isTrainingMod: false,
      Announcements: null,
      showAddTemplate: false,
      showWithdrawTemplate: false,
      isLoading: false,
      count: 0
      
    }
  }, 
  methods: {
    handleError(errors) {
      errors.forEach(error => {
      error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length>0;
    },
    fetchRoles() {
      for(var i=0; i< this.userInfo.roles.length; i++){
        if(this.userInfo.roles[i].name == "ADMIN" ) {
          this.isAdmin = true;
        } else if(this.userInfo.roles[i].name == "TRAINING_ADMIN") {
          this.isTrainingAdmin = true;
        } else if(this.userInfo.roles[i].name == "TRAINING_MOD"){
          this.isTrainingMod = true;
        }
      }
    },
    emitError(errorMessage) {
      this.$emit('error:api', errorMessage);
    },
    emitSuccess(successMessage) {
      this.$emit('success', successMessage);
    },
    getAnnouncementsTemplatesByCriteria() {
      trainingService.getAnnouncementTemplatesByCriteria().then(
        (response) => {
          this.Announcements = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    showWithdrawTemplateFn(template) {
      if (this.count!= 0){
        this.showWithdrawTemplate = false;
      }
      this.templateToWithdraw = template;
      this.showWithdrawTemplate = true;
      this.count = 1;
      window.scrollTo(0,0);
    },
    hideWithdrawTemplate() {
      this.isLoading = false;
      this.showWithdrawTemplate = false;
    },
    refreshList(message = null) {
      this.getAnnouncementsTemplatesByCriteria();
      this.showWithdrawTemplate = false;
      this.successMessage = message;
      this.popSuccessAlert = true;
      window.scroll(0,0);
    },
    deleteTemplate(){
      let TemplateDelete = {
        id: {
          id: this.templateToWithdraw.id
        },
        title: {
          title: this.templateToWithdraw.title.id
        }
      };    
      trainingService.deleteTemplate(TemplateDelete.id).then(
        (response) => {
          (this.refreshList(this.$t('parametrics.TemplateDeleted')));
          this.announcementdelete = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      )
    }
  }
}
</script>